export default [
    {
        path: 'feriado',
        component: () => import(
            /* webpackChunkName: 'cadastro-feriado' */
            '@/views/cadastro/feriado/Index'
        ),
        redirect: 'feriado/index',
        children: [
            {
                name: 'cadastro-feriado-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'cadastro-feriado' */
                    '@/views/cadastro/feriado/List.vue'
                ),
            },
            {
                name: 'cadastro-feriado-create',
                path: 'create',
                component: () => import(
                    /* webpackChunkName: 'cadastro-feriado' */
                    '@/views/cadastro/feriado/Form.vue'
                ),
            },
            {
                name: 'cadastro-feriado-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(
                    /* webpackChunkName: 'cadastro-feriado' */
                    '@/views/cadastro/feriado/Form.vue'
                ),
            },
        ],
    },
]